export default __webpack_public_path__ + "static/media/partying-face_1f973.32c3cf15.png";